import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "logo-container" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "build-container" }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["data-index", "onClick"]
const _hoisted_9 = { class: "config-tile" }
const _hoisted_10 = { class: "config-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_ctx.parameters.game)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "logo",
            src: _ctx.parameters.game.getImageUrl(),
            alt: _ctx.parameters.game.name
          }, null, 8, _hoisted_3),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openBuildSizeUrl && _ctx.openBuildSizeUrl(...args)))
          }, " View Build Size Info ")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.parameters.game.buildPrefix) = $event)),
            class: "prefixes-ddl ddl",
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateVersions && _ctx.updateVersions(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buildPrefixes, (prefix) => {
              return (_openBlock(), _createElementBlock("option", {
                key: prefix,
                value: prefix
              }, _toDisplayString(prefix), 9, _hoisted_5))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.parameters.game.buildPrefix]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.parameters.game.version) = $event)),
            class: "version-ddl ddl"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.versions, (ver) => {
              return (_openBlock(), _createElementBlock("option", {
                key: ver,
                value: ver
              }, _toDisplayString(ver), 9, _hoisted_6))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.parameters.game.version]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.parameters.game) = $event)),
            class: "game-ddl ddl",
            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.updateConfigs && _ctx.updateConfigs(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game) => {
              return (_openBlock(), _createElementBlock("option", {
                key: game.id,
                value: game
              }, _toDisplayString(game.name), 9, _hoisted_7))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.parameters.game]
          ])
        ]),
        (_ctx.configLoaded)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "configs-container",
              appear: "",
              onBeforeEnter: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.beforeEnter && _ctx.beforeEnter(...args))),
              onEnter: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.enter && _ctx.enter(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parameters.game.getConfigs(), (config, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "config",
                  "data-index": index,
                  onClick: ($event: any) => (_ctx.selectConfig(config))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_icon, {
                      icon: "cogs",
                      class: "icon"
                    }),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(config.name), 1)
                  ])
                ], 8, _hoisted_8))
              }), 128))
            ], 32))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}